export const baseUrl = "https://vishwak-backend-792856116943.asia-south1.run.app/api/v1";
export const productName = "GL Funnel";
export const clientCompanyName = "Vishwak Properties";